const STORAGE_KEY = 'js360_push_device_id';

export function getOrCreatePushDeviceId() {
  let id = sessionStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

export function clearPushDeviceId() {
  sessionStorage.removeItem(STORAGE_KEY);
}
